window.bundleDataT = {
"Talia-girl": {
displayName: "Talia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Talia Personalized Coloring Experience",
variantId: "49652563280109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Talia_final_cover.png?v=1773501523",
price: "$14.99",
preorder: true
},
{
title: "Talia Unicorn Holographic Sticker",
variantId: "49933754892525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Talia_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Talia Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Tammy-girl": {
displayName: "Tammy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tammy Personalized Coloring Experience",
variantId: "49983100715245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tammyfinalcover.png?v=1779026862",
price: "$14.99",
preorder: true
},
{
title: "Tammy Unicorn Holographic Sticker",
variantId: "49983093866733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tammysticker.png?v=1779025165",
price: "$4.99",
preorder: false
},
{
title: "Tammy Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Tara-girl": {
displayName: "Tara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tara Personalized Coloring Experience",
variantId: "49648672047341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tara_final_cover.png?v=1773501523",
price: "$14.99",
preorder: true
},
{
title: "Tara Unicorn Holographic Sticker",
variantId: "49933755023597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tara_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Tara Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Taylor-girl": {
displayName: "Taylor",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Taylor Personalized Coloring Experience",
variantId: "49279573852397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Taylor_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Taylor Unicorn Holographic Sticker",
variantId: "49933773734125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Taylor_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Taylor Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Thea-girl": {
displayName: "Thea",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Thea Personalized Coloring Experience",
variantId: "49647080407277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Thea_final_cover.png?v=1773501523",
price: "$14.99",
preorder: true
},
{
title: "Thea Unicorn Holographic Sticker",
variantId: "49933755351277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Thea_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Thea Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Theo-boy": {
displayName: "Theo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Theo Personalized Coloring Experience",
variantId: "49279574081773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Theo_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "Theo Dragon Holographic Sticker",
variantId: "49933773504749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Theo_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Theo Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Theodore-boy": {
displayName: "Theodore",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Theodore Personalized Coloring Experience",
variantId: "49279574245613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Theodore_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "Theodore Dragon Holographic Sticker",
variantId: "49933773406445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Theodore_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Theodore Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Theresa-girl": {
displayName: "Theresa",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Theresa Personalized Coloring Experience",
variantId: "49402727989485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Theresafinalfinalcover_44637c19-d879-45ea-9b2f-e87248fc79ec.png?v=1773331431",
price: "$14.99",
preorder: true
},
{
title: "Theresa Unicorn Holographic Sticker",
variantId: "49933767803117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Theresa_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Theresa Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Thiago-boy": {
displayName: "Thiago",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Thiago Personalized Coloring Experience",
variantId: "49279574376685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Thiago_final_cover.png?v=1771691711",
price: "$14.99",
preorder: true
},
{
title: "Thiago Dragon Holographic Sticker",
variantId: "49933773209837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Thiago_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Thiago Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Thomas-boy": {
displayName: "Thomas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Thomas Personalized Coloring Experience",
variantId: "49411991601389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/THOMAS_FINAL_COVER.png?v=1772032669",
price: "$14.99",
preorder: true
},
{
title: "Thomas Dragon Holographic Sticker",
variantId: "49933766918381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Thomas_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Thomas Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Tim-boy": {
displayName: "Tim",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tim Personalized Coloring Experience",
variantId: "49412005757165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TIM_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Tim Dragon Holographic Sticker",
variantId: "49933766590701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tim_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Tim Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Timothy-boy": {
displayName: "Timothy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Timothy Personalized Coloring Experience",
variantId: "49412005363949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TIMOTHY_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Timothy Dragon Holographic Sticker",
variantId: "49933766623469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Timothy_holographic_sticker.png?v=1780106108",
price: "$4.99",
preorder: false
},
{
title: "Timothy Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Tommy-boy": {
displayName: "Tommy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tommy Personalized Coloring Experience",
variantId: "49654831055085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tommy_final_cover.png?v=1773501516",
price: "$14.99",
preorder: true
},
{
title: "Tommy Dragon Holographic Sticker",
variantId: "49933754728685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tommy_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Tommy Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Tony-boy": {
displayName: "Tony",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tony Personalized Coloring Experience",
variantId: "49654582214893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tony_final_cover.png?v=1773501514",
price: "$14.99",
preorder: true
},
{
title: "Tony Dragon Holographic Sticker",
variantId: "49933754761453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tony_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Tony Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Travis-boy": {
displayName: "Travis",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Travis Personalized Coloring Experience",
variantId: "49431478567149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Travis_final_cover.png?v=1772388163",
price: "$14.99",
preorder: true
},
{
title: "Travis Dragon Holographic Sticker",
variantId: "49933759873261",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Travis_holographic_sticker.png?v=1780106108",
price: "$4.99",
preorder: false
},
{
title: "Travis Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Trenton-boy": {
displayName: "Trenton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Trenton Personalized Coloring Experience",
variantId: "49400132141293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Trenton_final_cover.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Trenton Dragon Holographic Sticker",
variantId: "49933769638125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Trenton_holographic_sticker.png?v=1780106107",
price: "$4.99",
preorder: false
},
{
title: "Trenton Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Trey-boy": {
displayName: "Trey",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Trey Personalized Coloring Experience",
variantId: "49400130044141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Trey_final_cover.png?v=1771691585",
price: "$14.99",
preorder: true
},
{
title: "Trey Dragon Holographic Sticker",
variantId: "49933769703661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Trey_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Trey Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Tristan-boy": {
displayName: "Tristan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tristan Personalized Coloring Experience",
variantId: "49400114282733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tristan_final_cover.png?v=1771691709",
price: "$14.99",
preorder: true
},
{
title: "Tristan Dragon Holographic Sticker",
variantId: "49933770227949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tristan_holographic_sticker.png?v=1780106112",
price: "$4.99",
preorder: false
},
{
title: "Tristan Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Tyler-boy": {
displayName: "Tyler",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tyler Personalized Coloring Experience",
variantId: "49414804734189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tyler.png?v=1772144833",
price: "$14.99",
preorder: true
},
{
title: "Tyler Dragon Holographic Sticker",
variantId: "49933760299245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tyler_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Tyler Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,

"Tylor-boy": {
displayName: "Tylor",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tylor Personalized Coloring Experience",
variantId: "49412004643053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TYLOR_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Tylor Dragon Holographic Sticker",
variantId: "49933766656237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tylor_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Tylor Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Tucker-boy": {
displayName: "Tucker",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tucker Personalized Coloring Experience",
variantId: "50180882366701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tucker_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Tucker Dragon Holographic Sticker",
variantId: "50180820566253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tuckerwebsitesticker.png?v=1782610771",
price: "$4.99",
preorder: false
},
{
title: "Tucker Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Tate-boy": {
displayName: "Tate",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tate Personalized Coloring Experience",
variantId: "50449676009709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tate_final_cover.png?v=1786244940",
price: "$14.99",
preorder: true
},
{
title: "Tate Dragon Holographic Sticker",
variantId: "50449559716077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tate_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Tate Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Tobias-boy": {
displayName: "Tobias",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Tobias Personalized Coloring Experience",
variantId: "50457736446189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tobias_final_cover.png?v=1786406748",
price: "$14.99",
preorder: true
},
{
title: "Tobias Dragon Holographic Sticker",
variantId: "50457706365165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Tobias_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Tobias Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} 




};